module.exports = "<button \n\tclass=\"button favorite-button button-block\" \n\tng-click=\"$ctrl.add()\"\n\tng-class=\"{ 'active': $ctrl.active }\">\n\t<i class=\"ion-android-favorite\"></i><span>{{ 'add_to_favorites' | translate | ucfirst }}</span>\n</button>"


//////////////////
// WEBPACK FOOTER
// ./app/components/favoriteButton/favoriteButton.html
// module id = 400
// module chunks = 0